import { request } from "./request.js";

export async function get(key) {
    return await request("/diagnosis", { key: key }, "POST");
}

export async function save(data) {
    return await request("/diagnosis/save", data, "POST");
}

export async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/diagnosis/list" + append, {}, "POST");
}

export async function checkupSave(data) {
    return await request("/checkup/diagnosis", data, "POST");
}
